export default "__VITE_PUBLIC_ASSET__23223458__"